import {
  // Staff Advance Types
  INITIATE_ADVANCE_PAYOUT,
  STAFF_DETAILS_FOR_ADVANCE,
  UPDATE_HR_STAFF_ADVANCE_REQUEST,
  FETCH_HR_STAFF_ADVANCE_ELIGIBILITY_BULK_SUCCESS,
  GETHRSTAFFADVANCEDASHBOARDKPIS,
  CHECKHRSTAFFADVANCEELIGIBILITY,
  PREVIEWHRSTAFFADVANCESCHEDULE,
  GETHRSTAFFADVANCEACCOUNTINGPREVIEW,
  RAISEHRSTAFFADVANCEREQUEST,
  GETHRSTAFFADVANCEREQUESTLIST,
  GETHRSTAFFADVANCEREQUESTDETAILS,
  APPROVEHRSTAFFADVANCEREQUEST,
  REJECTHRSTAFFADVANCEREQUEST,
  CANCELHRSTAFFADVANCEREQUEST,
  ISSUEHRSTAFFADVANCE,
  GETHRSTAFFADVANCELIST,
  GETHRSTAFFADVANCEDETAILS,
  RELEASEHRSTAFFADVANCE,
  CLOSEHRSTAFFADVANCE,
  REGENERATEHRSTAFFADVANCESCHEDULE,
  SAVEHRSTAFFADVANCEEMERGENCYDETAILS,
  GETHRSTAFFADVANCEEMERGENCYDETAILS,
  DELETEHRSTAFFADVANCEEMERGENCYDETAILS,
  UPLOADHRSTAFFADVANCEDOCUMENT,
  UPDATEHRSTAFFADVANCEDOCUMENT,
  DELETEHRSTAFFADVANCEDOCUMENT,
  GETHRSTAFFADVANCEDOCUMENTSLIST,

  // Payroll Recovery Types
  CREATEHRPAYROLLRECOVERY,
  GETHRPAYROLLRECOVERY,
  GETHRPAYROLLRECOVERYDETAILS,
  VERIFYHRPAYROLLRECOVERY,
  APPROVEHRPAYROLLRECOVERY,
  POSTHRPAYROLLRECOVERY,
  CANCELHRPAYROLLRECOVERY,

  // Fund Budget Types
  GET_HR_FUND_BUDGET,
  GET_HR_FUND_BUDGET_DETAILS,
  CREATE_HR_FUND_BUDGET,
  UPDATE_HR_FUND_BUDGET,
  DELETE_HR_FUND_BUDGET,

  // Approval Workflow Types
  CREATEHRAPPROVALWORKFLOW,
  GETHRAPPROVALWORKFLOWHISTORY,
  GETHRAPPROVALWORKFLOWPENDING,
  GETHRAPPROVALWORKFLOWDETAILS,
  UPDATEHRAPPROVALWORKFLOW,
  DELETEHRAPPROVALWORKFLOW,

  GET_HR_ADVANCE_TYPE_MASTER,
  CREATE_HR_ADVANCE_TYPE_MASTER,
  UPDATE_HR_ADVANCE_TYPE_MASTER,
  DELETE_HR_ADVANCE_TYPE_MASTER,
  GET_HR_RECOVERY_TYPE_MASTER,
  CREATE_HR_RECOVERY_TYPE_MASTER,
  UPDATE_HR_RECOVERY_TYPE_MASTER,
  DELETE_HR_RECOVERY_TYPE_MASTER,
  GET_HR_ADVANCE_MASTER,
  CREATE_HR_ADVANCE_MASTER,
  UPDATE_HR_ADVANCE_MASTER,
  DELETE_HR_ADVANCE_MASTER,


} from '../actions/types';

const initialState = {
  hrfundbudgetList: [],
  hrfundbudgetDetails: null,
  hrfundbudgetSaveStatus: null,
  hrfundbudgetUpdateStatus: null,
  hrfundbudgetDeleteStatus: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {

    // ─── HR STAFF ADVANCE ──────────────────────────────────────────
    case GETHRSTAFFADVANCEDASHBOARDKPIS:
      return {
        ...state,
        hrstaffadvanceDashboardKPIs: action.payload.data,
      };
    case CHECKHRSTAFFADVANCEELIGIBILITY:
      return {
        ...state,
        hrstaffadvanceEligibility: action.payload.data,
      };
    case PREVIEWHRSTAFFADVANCESCHEDULE:
      return {
        ...state,
        hrstaffadvanceSchedulePreview: action.payload.data,
      };
    case GETHRSTAFFADVANCEACCOUNTINGPREVIEW:
      return {
        ...state,
        hrstaffadvanceAccountingPreview: action.payload.data,
      };
    case RAISEHRSTAFFADVANCEREQUEST:
      return {
        ...state,
        hrstaffadvanceRequestSaveStatus: action.payload.success,
      };
    case GETHRSTAFFADVANCEREQUESTLIST:
      return {
        ...state,
        hrstaffadvanceRequestList: action.payload.data,
      };
    case GETHRSTAFFADVANCEREQUESTDETAILS:
      return {
        ...state,
        hrstaffadvanceRequestDetails: action.payload.data,
      };
    case APPROVEHRSTAFFADVANCEREQUEST:
      return {
        ...state,
        hrstaffadvanceRequestApproveStatus: action.payload.success,
      };
    case REJECTHRSTAFFADVANCEREQUEST:
      return {
        ...state,
        hrstaffadvanceRequestRejectStatus: action.payload.success,
      };
    case CANCELHRSTAFFADVANCEREQUEST:
      return {
        ...state,
        hrstaffadvanceRequestCancelStatus: action.payload.success,
      };
    case ISSUEHRSTAFFADVANCE:
      return {
        ...state,
        hrstaffadvanceIssueSaveStatus: action.payload.success,
      };
    case GETHRSTAFFADVANCELIST:
      return {
        ...state,
        hrstaffadvanceList: action.payload.data,
      };
    case GETHRSTAFFADVANCEDETAILS:
      return {
        ...state,
        hrstaffadvanceDetails: action.payload.data,
      };
    case RELEASEHRSTAFFADVANCE:
      return {
        ...state,
        hrstaffadvanceReleaseStatus: action.payload.success,
      };
    case CLOSEHRSTAFFADVANCE:
      return {
        ...state,
        hrstaffadvanceCloseStatus: action.payload.success,
      };
    case REGENERATEHRSTAFFADVANCESCHEDULE:
      return {
        ...state,
        hrstaffadvanceRegenerateScheduleStatus: action.payload.success,
      };
    case SAVEHRSTAFFADVANCEEMERGENCYDETAILS:
      return {
        ...state,
        hrstaffadvanceEmergencyDetailsSaveStatus: action.payload.success,
      };
    case GETHRSTAFFADVANCEEMERGENCYDETAILS:
      return {
        ...state,
        hrstaffadvanceEmergencyDetails: action.payload.data,
      };
    case DELETEHRSTAFFADVANCEEMERGENCYDETAILS:
      return {
        ...state,
        hrstaffadvanceEmergencyDetailsDeleteStatus: action.payload.success,
      };
    case UPLOADHRSTAFFADVANCEDOCUMENT:
      return {
        ...state,
        hrstaffadvanceDocumentSaveStatus: action.payload.success,
      };
    case UPDATEHRSTAFFADVANCEDOCUMENT:
      return {
        ...state,
        hrstaffadvanceDocumentUpdateStatus: action.payload.success,
      };
    case DELETEHRSTAFFADVANCEDOCUMENT:
      return {
        ...state,
        hrstaffadvanceDocumentDeleteStatus: action.payload.success,
      };
    case GETHRSTAFFADVANCEDOCUMENTSLIST:
      return {
        ...state,
        hrstaffadvanceDocumentsList: action.payload.data,
      };

    // ─── HR PAYROLL RECOVERY ───────────────────────────────────────
    case CREATEHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoverySaveStatus: action.payload.success,
      };
    case GETHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoveryList: action.payload.data,
      };
    case GETHRPAYROLLRECOVERYDETAILS:
      return {
        ...state,
        hrpayrollrecoveryDetails: action.payload.data,
      };
    case VERIFYHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoveryVerifyStatus: action.payload.success,
      };
    case APPROVEHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoveryApproveStatus: action.payload.success,
      };
    case POSTHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoveryPostStatus: action.payload.success,
      };
    case CANCELHRPAYROLLRECOVERY:
      return {
        ...state,
        hrpayrollrecoveryCancelStatus: action.payload.success,
      };

    // ─── HR FUND BUDGET ───────────────────────────────────────────
    case GET_HR_FUND_BUDGET:
      return {
        ...state,
        hrfundbudgetList: action.payload.data || [],
      };
    case GET_HR_FUND_BUDGET_DETAILS:
      return {
        ...state,
        hrfundbudgetDetails: action.payload.data || null,
      };
    case CREATE_HR_FUND_BUDGET:
      return {
        ...state,
        hrfundbudgetSaveStatus: action.payload.success,
      };
    case UPDATE_HR_FUND_BUDGET:
      return {
        ...state,
        hrfundbudgetUpdateStatus: action.payload.success,
      };
    case DELETE_HR_FUND_BUDGET:
      return {
        ...state,
        hrfundbudgetDeleteStatus: action.payload.success,
      };


    // ─── HR APPROVAL WORKFLOW ──────────────────────────────────────
    case CREATEHRAPPROVALWORKFLOW:
      return {
        ...state,
        hrapprovalworkflowSaveStatus: action.payload.success,
      };
    case GETHRAPPROVALWORKFLOWHISTORY:
      return {
        ...state,
        hrapprovalworkflowHistoryList: action.payload.data,
      };
    case GETHRAPPROVALWORKFLOWPENDING:
      return {
        ...state,
        hrapprovalworkflowPendingList: action.payload.data,
      };
    case GETHRAPPROVALWORKFLOWDETAILS:
      return {
        ...state,
        hrapprovalworkflowDetails: action.payload.data,
      };
    case UPDATEHRAPPROVALWORKFLOW:
      return {
        ...state,
        hrapprovalworkflowUpdateStatus: action.payload.success,
      };
    case DELETEHRAPPROVALWORKFLOW:
      return {
        ...state,
        hrapprovalworkflowDeleteStatus: action.payload.success,
      };

    case GET_HR_ADVANCE_TYPE_MASTER:
      return { ...state, hrAdvanceTypeMasterList: action.payload.data };
    case CREATE_HR_ADVANCE_TYPE_MASTER:
      return { ...state, hrAdvanceTypeMasterSaveStatus: action.payload.success };
    case UPDATE_HR_ADVANCE_TYPE_MASTER:
      return { ...state, hrAdvanceTypeMasterUpdateStatus: action.payload.success };
    case DELETE_HR_ADVANCE_TYPE_MASTER:
      return { ...state, hrAdvanceTypeMasterDeleteStatus: action.payload.success };

    case GET_HR_RECOVERY_TYPE_MASTER:
      return { ...state, hrRecoveryTypeMasterList: action.payload.data };
    case CREATE_HR_RECOVERY_TYPE_MASTER:
      return { ...state, hrRecoveryTypeMasterSaveStatus: action.payload.success };
    case UPDATE_HR_RECOVERY_TYPE_MASTER:
      return { ...state, hrRecoveryTypeMasterUpdateStatus: action.payload.success };
    case DELETE_HR_RECOVERY_TYPE_MASTER:
      return { ...state, hrRecoveryTypeMasterDeleteStatus: action.payload.success };

    case GET_HR_ADVANCE_MASTER:
      return { ...state, hrAdvanceMasterList: action.payload.data };
    case CREATE_HR_ADVANCE_MASTER:
      return { ...state, hrAdvanceMasterSaveStatus: action.payload.success };
    case UPDATE_HR_ADVANCE_MASTER:
      return { ...state, hrAdvanceMasterUpdateStatus: action.payload.success };
    case DELETE_HR_ADVANCE_MASTER:
      return { ...state, hrAdvanceMasterDeleteStatus: action.payload.success };

    // Include bulk eligibility case inside your switch reducer block
    case FETCH_HR_STAFF_ADVANCE_ELIGIBILITY_BULK_SUCCESS:
      return {
        ...state,
        hrstaffadvanceEligibilityBulk: action.payload.data
      };

    case UPDATE_HR_STAFF_ADVANCE_REQUEST:
      return {
        ...state,
        hrstaffadvanceRequestUpdateStatus: action.payload.success,
      };

    case STAFF_DETAILS_FOR_ADVANCE:
      return {
        ...state,
        hrstaffadvanceStaffDetailsList: action.payload.data,
      };



    default:
      return state;
  }
}